const prepareActions = {
  movePromiseToMeta({ values, resolve, reject }) {
    return {
      payload: values,
      meta: {
        resolve,
        reject,
      },
    };
  },
  withNavigate({ values, navigate }) {
    return {
      payload: values,
      meta: {
        navigate,
      },
    };
  },
  withPromiseNavigate({
    values, navigate, resolve, reject,
  }) {
    return {
      payload: values,
      meta: {
        navigate,
        resolve,
        reject,
      },
    };
  },
};

export default prepareActions;
